import { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

import { dbPlan } from "../firebasePlan";

export default function PlannerDb() {
  const [name, setName] = useState("");
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");

  const [records, setRecords] = useState([]);
  const [search, setSearch] = useState("");

  const plannerRef = collection(dbPlan, "planner");

  // Load records
  const loadRecords = async () => {
    try {
      const snapshot = await getDocs(plannerRef);

      const data = snapshot.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));

      data.sort((a, b) =>
        (a.name || "").localeCompare(b.name || "")
      );

      setRecords(data);
    } catch (error) {
      console.error("Error loading Planner:", error);
    }
  };

  useEffect(() => {
    loadRecords();
  }, []);

  // Save record
  const saveRecord = async () => {
    if (!name.trim() || !key.trim() || !value.trim()) {
      alert("Please enter Name, Key and Value.");
      return;
    }

    try {
      await addDoc(plannerRef, {
        name: name.trim(),
        key: key.trim(),
        value: value.trim(),
        createdAt: serverTimestamp(),
      });

      setName("");
      setKey("");
      setValue("");

      loadRecords();
    } catch (error) {
      console.error("Error saving Planner record:", error);
      alert("Error saving record.");
    }
  };

  // Delete record
  const deleteRecord = async (id) => {
    if (!window.confirm("Delete this record?")) return;

    try {
      await deleteDoc(doc(dbPlan, "planner", id));
      loadRecords();
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  // Search by name
  const filteredRecords = records.filter((item) =>
    (item.name || "")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "30px auto",
        padding: "20px",
        fontFamily: "Arial",
      }}
    >
      <h2 style={{ textAlign: "center" }}>Planner DB</h2>

      {/* ADD */}
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "10px",
          padding: "20px",
          marginBottom: "25px",
        }}
      >
        <h3>Add Record</h3>

        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={inputStyle}
        />

        <button onClick={saveRecord} style={saveButtonStyle}>
          SAVE
        </button>
      </div>

      {/* SEARCH */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Search by Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            ...inputStyle,
            fontSize: "18px",
            padding: "12px",
          }}
        />
      </div>

      {/* RESULTS */}
      <div>
        {search.trim() !== "" && filteredRecords.length === 0 && (
          <p style={{ textAlign: "center" }}>
            No records found.
          </p>
        )}

        {search.trim() !== "" &&
          filteredRecords.map((item) => (
            <div
              key={item.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "15px",
                marginBottom: "10px",
                background: "#f8f8f8",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >
                {item.name}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "120px 1fr",
                  gap: "8px",
                  fontSize: "17px",
                }}
              >
                <strong>Key:</strong>
                <span>{item.key}</span>

                <strong>Value:</strong>
                <span>{item.value}</span>
              </div>

              <button
                onClick={() => deleteRecord(item.id)}
                style={{
                  marginTop: "12px",
                  padding: "6px 12px",
                  border: "none",
                  borderRadius: "5px",
                  background: "#a60065",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          ))}
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "10px",
  marginBottom: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "16px",
};

const saveButtonStyle = {
  width: "100%",
  padding: "12px",
  border: "none",
  borderRadius: "6px",
  background: "#071d49",
  color: "white",
  fontSize: "17px",
  fontWeight: "bold",
  cursor: "pointer",
};